import React from 'react';
import About from '../components/About/About';

const AboutPage: React.FC = () => {
  return (
    <>
      <About className="about-page" />
    </>
  );
};

export default AboutPage;
